/* eslint-disable no-lonely-if */
/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import * as Constants from './constants';

// import { setSession } from '../Helpers/index';
import { getErrorLogObj } from '../../../services/loggerService';
// import { saveItemToStore } from '../../utils/sessionStorage';
// import { redirectTo } from '../../redirection';
import logger from '../ErrorBoundary/logger_new';
import { getSecureBaseUrl } from '../../../services/UrlMapperService';
import { apiUrls } from '../../../constants/apiUrl';
import { showLoader, hideLoader } from '../Helpers/loader';

function* sessionKeepALive({ data }) {
  //   yield put({ type: Constants.ASYNC_FETCH });
  try {
    showLoader();
    const apiResponse = yield call(Actions.sessionKeepAliveAPI, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.SESSION_ALIVE_SUCCESS });
      hideLoader();
    } else {
      if (apiResponse?.data?.errors) {
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `sessionKeepALive ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
      }
      hideLoader();
    }
  } catch (error) {
    // yield put({ type: Constants.ERR_OCCURED });
    // logError('sessionKeepALive', error, FE_API_ERROR);
    if (error) {
      const errorLog = getErrorLogObj({
        note: 'from sessionKeepALive sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().sessionKeepAlive}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errorLog);
    }
    hideLoader();
  }
  // yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* sessionKeepAliveSilent({ data }) {
  try {
    // showLoader();
    const apiResponse = yield call(Actions.sessionKeepAliveAPI, data);
    if (apiResponse && apiResponse.data && apiResponse?.data?.errors) {
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `sessionKeepALive ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
    }
    // / hideLoader();
  } catch (error) {
    if (error) {
      const errorLog = getErrorLogObj({
        note: 'from sessionKeepALive sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().sessionKeepAlive}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errorLog);
    }
    hideLoader();
  }
}

// for App schedule
function* sessionLogoff({ data }) {
  try {
    showLoader();
    const apiResponse = yield call(Actions.sessionLogoffAPI, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      hideLoader();
      yield put({ type: Constants.SESSION_LOGOFF_SUCCESS });
    } else {
      if (apiResponse?.data?.errors) {
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `sessionLogoff ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
      }
      hideLoader();
      yield put({ type: Constants.SESSION_LOGOFF_SUCCESS });
    }
  } catch (error) {
    // yield put({ type: Constants.ERR_OCCURED });
    // logError('sessionLogoff', error, FE_API_JS_ERROR);
    if (error) {
      logger({
        json: true,
        eventType: 'FeError',
        message: 'Looks like something went wrong. Please try again later.',
        note: 'from sessionLogoff sagas'.concat(error?.message ? error?.message : ''),
        messageType: 'ERROR',
        errorCategory: 'API-ERROR',
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().sessionLogoff}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
    }
    yield put({ type: Constants.SESSION_LOGOFF_SUCCESS });
    hideLoader();
  }
  //   yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* actionWatcher() {
  yield takeLatest('SESSION_KEEP_ALIVE', sessionKeepALive);
  yield takeLatest('SESSION_LOGOFF', sessionLogoff);
  yield takeLatest('SESSION_KEEP_ALIVE_SILENT', sessionKeepAliveSilent);
  // SAVE_SELF_INSTALL_DATE
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
